module.exports = __webpack_public_path__ + "img/i8.1f1f4fd6.svg";